import { Link } from "react-router-dom";
import React, { useState } from "react";
import { Carousel, Card } from "flowbite-react";

const Project = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const projects = [
    {
      id: 1,
      date: "2023",
      role: "All Rounder",
      shortcut: "Undergrad Thesis",
      name: "Visual-to-Speech SIBI Recognition System Using LSTM",
      subname: "Undergraduate Thesis",
      stacks: ["Python", "Mediapipe", "OpenCV", "Tensorflow"],
      link: "https://repository.its.ac.id/102673/",
      image: [
        "img/ta1.png",
        "img/ta2.png",
        "img/ta3.png",
        "img/ta4.png",
        "img/ta5.png",
      ],
      detail: `This research was conducted to develop an assistive technology that bridges the gap between hearing and speech-impaired Indonesian individuals and those who do not understand sign language. 
      The system is capable of recognizing Indonesian Sign Language (SIBI) gestures and converting them into speech. Consequently, non-disabled individuals can comprehend the gestures of impaired individuals without prior knowledge of sign language. 
      This research involved a dataset of 900 samples within 50 classes, captured from video using the Mediapipe library. The model was trained using Long Short-Term Memory (LSTM), which effectively captures temporal information and patterns from the dataset.`,
    },
    {
      id: 2,
      date: "2023",
      role: "All Rounder",
      shortcut: "SOTOPANAS",
      name: "SOTOPANAS - Sistem Online Terpadu Pelayanan Aduan Masyarakat Surabaya",
      subname:
        "Dinas Penanaman Modal dan Pelayanan Terpadu Satu Pintu Kota Surabaya",
      stacks: ["Laravel", "Flowbite"],
      image: ["img/sp1.png", "img/sp2.png", "img/sp3.png"],
      detail:
        "This website was developed to manage and maintain public feedback and complaints data related to the Department's public service. This management system was built for internal purposes as a repository and to monitor the completion progress of feedback and complaints. Additionally, monthly reports can be generated from this system as evaluation material for discussion and improvement.",
    },
    {
      id: 3,
      date: "2024",
      shortcut: "Peta Potensi",
      role: "Fullstack Developer",
      name: "Peta Potensi Investasi",
      subname:
        "Dinas Penanaman Modal dan Pelayanan Terpadu Satu Pintu Kota Surabaya",
      stacks: ["Laravel", "Leafletjs", "Flowbite"],
      link: "https://dpm-ptsp.surabaya.go.id/petapotensi",
      image: [
        "img/pp1.png",
        "img/pp2.png",
        "img/pp3.png",
        "img/pp4.png",
        "img/pp5.png",
      ],
      detail:
        "This geolocation-based website was built to provide information about potential investment opportunities in Surabaya and offers local government assets to develop the economic atmosphere. The website also provides information about investment opportunities and support in Surabaya.",
    },
    {
      id: 4,
      date: "2024-2025",
      role: "Fullstack Developer",

      shortcut: "Kalkulator Investasi",
      name: "Kalkulator Investasi",
      subname:
        "Dinas Penanaman Modal dan Pelayanan Terpadu Satu Pintu Kota Surabaya",
      stacks: ["Laravel", "Flowbite"],
      link: "https://dpm-ptsp.surabaya.go.id/kalkulator_investasi",
      image: ["img/ki1.png", "img/ki2.png", "img/ki3.png", "img/ki4.png"],
      detail:
        "This application is designed to plan, estimate, and forecast investment values in various sectors and fields to predict profit, risk, and feasibility. The application also provides recommendations and suggestions to users, such as possible locations, sector distribution, and legal support, to help them make informed decisions before proceeding with execution.",
    },
    {
      id: 5,
      date: "2024-2025",
      role: "Project Manager & Fullstack Developer",

      shortcut: "SiAMATi",
      subname:
        "Dinas Penanaman Modal dan Pelayanan Terpadu Satu Pintu Kabupaten Mimika Provinsi Papua Tengah",
      stacks: ["Laravel", "Flowbite"],
      name: "SiAMATi",
      link: "https://siamati.dpmptspkabmmk.id/",
      image: ["img/sia1.png", "img/sia2.png", "img/sia3.png", "img/sia4.png"],
      detail:
        "This website was built with the same purpose as SOTOPANAS, as a result of benchmarking the product from the Surabaya City Government. This website has slightly improved features since it is intended for both government and public use. The interactivity between the government and the public is more intense on this website.",
    },
    {
      id: 6,
      date: "2024-2025",
      role: "Project Manager  & Fullstack Developer",

      shortcut: "TSW",
      subname:
        "Dinas Penanaman Modal dan Pelayanan Terpadu Satu Pintu Kabupaten Mimika Provinsi Papua Tengah",
      stacks: ["Laravel", "Flowbite"],
      name: "Timika Single Window",
      image: ["img/tsw1.png", "img/tsw2.png", "img/tsw3.png", "img/tsw4.png"],
      detail:
        "Imitating the concept of Surabaya Single Window, this website was built to maintain legal permission certificates and licenses data in Mimika. The Mimika government aims to transform archive management into a digital system and service. However, the public still cannot commit to self-service on this website to accelerate obtaining legal certificates and licenses. In other words, the Person-in-Charge will no longer use a paper-based system, and archive management will be well-structured and fully organized.",
    },
    {
      id: 7,
      date: "2025",
      role: "Project Manager & Fullstack Developer",
      name: "SIPINTAR",

      shortcut: "SIPINTAR",
      subname:
        "Dinas Penanaman Modal dan Pelayanan Terpadu Satu Pintu Kota Surabaya",
      stacks: ["Laravel", "Flowbite"],
      link: "https://dpm-ptsp.surabaya.go.id/sipintar",
      image: ["img/sip1.png", "img/sip2.png", "img/sip3.png"],
      detail:
        "This rule-based and text-preprocessed chatbot application provides information about legal licensing permissions for investment and non-investment activities in Surabaya. The application aims to provide quick access to information, eliminating the need for the public to conduct manual searches in SSW. The public also does not need to call or contact support agents, as the chatbot can answer general questions. ",
    },
    {
      id: 8,
      date: "2025",
      role: "Project Manager & Fullstack Developer",
      name: "Mal Pelayanan Publik Kabupaten Mimika",

      shortcut: "MPP Mimika",
      subname:
        "Dinas Penanaman Modal dan Pelayanan Terpadu Satu Pintu Kabupaten Mimika",
      stacks: ["Laravel", "Flowbite"],
      link: "https://mpp.mimikakab.go.id",
      image: [
        "img/mppm1.png",
        "img/mppm2.PNG",
        "img/mppm3.PNG",
        "img/mppm4.PNG",
      ],
      detail:
        "This landing page was built to provide information about public services in Mimika. The website serves as a gateway for the public to access various services provided by the government. It includes information about available services, procedures, and requirements, making it easier for citizens to navigate and utilize government services effectively. it also includes survey features to gather feedback from the public regarding the services provided.",
    },
  ];
  // Responsive Project Carousel Component

  // State for which project is selected in the carousel
  const [projectIndex, setProjectIndex] = useState(0);
  // State for which image is selected in the mobile image carousel
  const [imageIndex, setImageIndex] = useState(0);

  // Handle project change (main carousel)
  const handleProjectChange = (idx) => {
    setProjectIndex(idx);
    setImageIndex(0); // reset image index when project changes
  };

  // Handle image change (mobile carousel)
  const handleImageChange = (idx) => {
    setImageIndex(idx);
  };

  // Swipe handlers for mobile image carousel
  const handleSwipe = (direction) => {
    const images = projects[projectIndex].image;
    if (direction === "left") {
      setImageIndex((prev) => (prev + 1) % images.length);
    } else if (direction === "right") {
      setImageIndex((prev) => (prev - 1 + images.length) % images.length);
    }
  };

  // Touch event state for swipe
  const [touchStartX, setTouchStartX] = useState(null);

  const onTouchStart = (e) => {
    setTouchStartX(e.touches[0].clientX);
  };

  const onTouchEnd = (e) => {
    if (touchStartX === null) return;
    const touchEndX = e.changedTouches[0].clientX;
    const diff = touchStartX - touchEndX;
    if (Math.abs(diff) > 40) {
      handleSwipe(diff > 0 ? "left" : "right");
    }
    setTouchStartX(null);
  };

  return (
    <div className="flex flex-col min-h-screen w-full bg-cream">
      <div className="w-full flex flex-col items-center">
        <div className="w-full text-center py-8">
          <p className="tracking-widest font-bold text-4xl sm:text-6xl md:text-7xl text-orangee animate__animated animate__slideInRight">
            PROJECTS
          </p>
        </div>
        <div className="w-full flex flex-col items-center">
          {/* Project Carousel Buttons */}
          <div className="flex flex-wrap justify-center gap-2 mb-4">
            {projects.map((project, idx) => (
              <button
                key={project.id}
                className={`px-3 py-1 rounded-lg border-2 border-orangee text-xs md:text-sm font-semibold transition-all duration-200 ${
                  idx === projectIndex
                    ? "bg-orangee text-white scale-105"
                    : "bg-white text-orangee hover:bg-orangee hover:text-white"
                }`}
                onClick={() => handleProjectChange(idx)}
                aria-label={`Go to project ${project.name}`}
              >
                {project.shortcut}
              </button>
            ))}
          </div>
          {/* Project Card */}
          <div className="w-full max-w-4xl bg-white rounded-xl shadow-lg p-4 md:p-8 flex flex-col md:flex-row gap-8 items-center">
            {/* Images */}
            <div className="w-full md:w-1/2 flex flex-col items-center">
              {/* Desktop: show all images in a grid */}
              <div className="hidden md:grid grid-cols-2 gap-2 w-full">
                {projects[projectIndex].image.map((img, idx) => (
                  <img
                    key={idx}
                    src={img}
                    alt={`Project ${projectIndex + 1} img ${idx + 1}`}
                    className="rounded-lg object-cover w-full h-fit"
                    loading="lazy"
                  />
                ))}
              </div>
              {/* Mobile: show one image with swipe and dots */}
              <div
                className="md:hidden w-full flex flex-col items-center"
                onTouchStart={onTouchStart}
                onTouchEnd={onTouchEnd}
              >
                <img
                  src={projects[projectIndex].image[imageIndex]}
                  alt={`Project ${projectIndex + 1} img ${imageIndex + 1}`}
                  className="rounded-lg object-cover w-full h-56 transition-all duration-300"
                  loading="lazy"
                />
                <div className="flex justify-center items-center mt-2">
                  {projects[projectIndex].image.map((_, idx) => (
                    <button
                      key={idx}
                      className={`h-2.5 w-2.5 rounded-full mx-1 border border-orangee ${
                        idx === imageIndex ? "bg-orangee scale-110" : "bg-white"
                      }`}
                      onClick={() => handleImageChange(idx)}
                      aria-label={`Go to image ${idx + 1}`}
                    />
                  ))}
                </div>
              </div>
            </div>
            {/* Project Info */}
            <div className="w-full md:w-1/2 flex flex-col gap-2">
              <h2 className="text-xl md:text-3xl font-bold text-orangee">
                {projects[projectIndex].name}
              </h2>
              <p className="text-sm md:text-lg text-gray-700">
                {projects[projectIndex].subname} - {projects[projectIndex].date}
              </p>
              <p className="text-xs md:text-sm font-semibold text-gray-600">
                Participated as the {projects[projectIndex].role}
              </p>
              {projects[projectIndex].link ? (
                <a
                  href={projects[projectIndex].link}
                  className="font-semibold text-xs text-blue-600 mt-2 break-all"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {projects[projectIndex].link}
                </a>
              ) : (
                <p className="font-semibold text-xs text-red-600 mt-2">
                  Inaccessible restricted link. For internal use only.
                </p>
              )}
              {projects[projectIndex].detail && (
                <p className="text-xs md:text-sm mt-2 text-gray-800">
                  {projects[projectIndex].detail}
                </p>
              )}
              {projects[projectIndex].stacks && (
                <div className="flex flex-wrap gap-2 mt-4">
                  {projects[projectIndex].stacks.map((stack, idx) => (
                    <span
                      key={idx}
                      className="bg-orangee px-2 py-1 rounded-lg text-white text-xs"
                    >
                      {stack}
                    </span>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Project;
